'use strict';

module.exports = {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active'
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-pagination-2/compiled/themes/bootstrap4.js
// module id = 569
// module chunks = 4